// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"523":"shop","818":"auth","929":"terms","981":"rules"}[chunkId] + "." + {"523":"94a0b7bf","818":"bb15ae17","929":"e8429bde","981":"fcf8590e"}[chunkId] + ".js";
};